import { httpService } from '../..';
import { ApiUrls } from '../ApiUrls';
import { ISalesDashboardFilters } from '../filters';
import { ISalesDashboardApiResponse } from './dashboardInterfaces';

export async function fetchSalesDashboard(filters: ISalesDashboardFilters): Promise<ISalesDashboardApiResponse> {
  try {
    const response = await httpService.get(ApiUrls.getSalesDashboard(filters));
    return await response.json();
  } catch (e) {
    throw e;
  }
}
